module.exports = __webpack_public_path__ + "static/img/no.30545e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/no.png
// module id = RImv
// module chunks = 18